import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { FileText } from 'lucide-react';

const quickRanges = [
  { key: 'today', label: 'Today', testId: 'quick-today' },
  { key: 'week', label: 'Last 7 Days', testId: 'quick-week' },
  { key: 'month', label: 'This Month', testId: 'quick-month' },
  { key: 'last_month', label: 'Last Month', testId: 'quick-last-month' }
];

export const ReportFilters = ({
  workers,
  selectedWorker,
  setSelectedWorker,
  dateRange,
  setDateRange,
  onQuickRange
}) => (
  <Card className="bg-white border border-[#D1D1CD] rounded-lg shadow-sm">
    <CardHeader>
      <CardTitle className="text-lg font-semibold text-[#1C1C1E] flex items-center gap-2">
        <FileText className="w-5 h-5 text-[#2E4632]" />
        Report Filters
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-2">
        {quickRanges.map((range) => (
          <Button
            key={range.key}
            variant="outline"
            size="sm"
            data-testid={range.testId}
            onClick={() => onQuickRange(range.key)}
            className="h-10 border-[#D1D1CD] hover:bg-[#E8E8E3]"
          >
            {range.label}
          </Button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label className="text-sm font-medium text-[#5C5C5C]">Worker</Label>
          <Select value={selectedWorker} onValueChange={setSelectedWorker}>
            <SelectTrigger data-testid="report-worker-select" className="h-12 border-[#D1D1CD]">
              <SelectValue placeholder="Select worker" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Workers</SelectItem>
              {workers.map(worker => (
                <SelectItem key={worker.id} value={worker.id}>
                  {worker.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-sm font-medium text-[#5C5C5C]">Start Date</Label>
          <Input
            type="date"
            data-testid="report-start-date"
            value={dateRange.start_date}
            onChange={(e) => setDateRange({ ...dateRange, start_date: e.target.value })}
            className="h-12 border-[#D1D1CD]"
          />
        </div>

        <div className="space-y-2">
          <Label className="text-sm font-medium text-[#5C5C5C]">End Date</Label>
          <Input
            type="date"
            data-testid="report-end-date"
            value={dateRange.end_date}
            onChange={(e) => setDateRange({ ...dateRange, end_date: e.target.value })}
            className="h-12 border-[#D1D1CD]"
          />
        </div>
      </div>
    </CardContent>
  </Card>
);
